import React from 'react'
// import {Link} from 'react-router-dom'

import './style.css'


const Story = () =>{
    return(
        <div id="story" className="story-area section-padding">
            <div className="container">
                <div className="col-l2">
                    <div className="section-title text-center">
                        <h2>Our Story</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="story clearfix">
                            <div className="story-top"></div>
                            <div className="content-wrapper">
                                <div className="item">
                                    <div className="story-icon icon-left-mob">
                                        <span className="flaticon-heart"></span>
                                    </div>
                                    <div className="story-content">
                                        <div className="image-wrap">
                                            <div className="single-image">
                                                <div>
                                                <img  src='/images/story/1.png' alt='w'/>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <h2>First time we met</h2>
                                        <span className="date">July 20, 2017</span> */}
                                        <p>Η αγάπη μας ξεκίνησε στην όμορφη Θεσσαλονίκη. Συναντήσαμε το άλλο μας ολόκληρο, και κάπως έτσι ξεκινήσαμε…</p>
                                        {/* <div className="story-button">
                                            <Link className="theme-btn" to="/"  title="READ MORE">READ MORE</Link>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="story-icon">
                                        <span className="flaticon-heart"></span>
                                    </div>
                                    <div className="story-content">
                                        <div className="image-wrap">
                                            <div className="single-image">
                                                <div>
                                                <img  src='/images/story/2.png' alt='w'/>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <h2>Our First Date</h2>
                                        <span className="date">Dec 25, 2017</span> */}
                                       <p>Γιατί η ευτυχία δεν είναι ολοκληρωμένη αν δεν τη μοιράζεσαι με εκείνον που αγαπάς.</p>
                                        
                                        {/* <div className="story-button">
                                            <Link className="theme-btn" to="/"  title="READ MORE">READ MORE</Link>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="story-icon icon-left-mob">
                                        <span className="flaticon-heart"></span>
                                    </div>
                                    <div className="story-content">
                                        <div className="image-wrap">
                                            <div className="single-image">
                                                <div>
                                                <img  src='/images/story/3a.png' alt='w'/>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <h2>Our Marriage Proposal</h2>
                                        <span className="date">Jan 10, 2018</span> */}
                                        <p>Μέσα σε όλα αυτά τα χρόνια, ταξιδέψαμε, ερωτευτήκαμε, γνωριστήκαμε, απολαύσαμε στιγμές, γελάσαμε με την καρδιά μας…</p>
                                       
                                        {/* <div className="story-button">
                                            <Link className="theme-btn" to="/"  title="READ MORE">READ MORE</Link>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="story-icon">
                                        <span className="flaticon-heart"></span>
                                    </div>
                                    <div className="story-content">
                                        <div className="image-wrap">
                                            <div className="single-image">
                                                <div>
                                                {/* <img  src='/images/story/3b.png' alt='w'/> */}
                                                <img  src='/images/story/4.png' alt='w'/>

                                                </div>
                                            </div>
                                        </div>
                                        {/* <h2>Our Engagement</h2>
                                        <span className="date">Jan 22, 2018</span> */}
                                        <p>Στα δύσκολα και στα εύκολα κρατήσαμε ο ένας το χέρι του άλλου. </p>
                                        
                                        {/* <div className="story-button">
                                            <Link className="theme-btn" to="/"  title="READ MORE">READ MORE</Link>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="story-icon icon-left-mob">
                                        <span className="flaticon-heart"></span>
                                    </div>
                                    <div className="story-content">
                                        <div className="image-wrap">
                                            <div className="single-image">
                                                <div>
                                                <img  src='/images/story/5.png' alt='w'/>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <h2>Our Marriage Proposal</h2>
                                        <span className="date">Jan 10, 2018</span> */}
                                        <p>Πάντα μαζί… Εγώ & Εσύ, Εσύ & Εγώ…</p>
                                        
                                        {/* <div className="story-button">
                                            <Link className="theme-btn" to="/"  title="READ MORE">READ MORE</Link>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="story-icon">
                                        <span className="flaticon-heart"></span>
                                    </div>
                                    <div className="story-content">
                                        <div className="image-wrap">
                                            <div className="single-image">
                                                <div>
                                                <img  src='/images/story/6.png' alt='w'/>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <h2>Our Engagement</h2>
                                        <span className="date">Jan 22, 2018</span> */}
                                        <p>Μετά από 9 ολόκληρα χρόνια, έφτασε το σημαντικότερο ραντεβού της ζωής μας.</p>

                                        {/* <div className="story-button">
                                            <Link className="theme-btn" to="/"  title="READ MORE">READ MORE</Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            <div className="story-bottom">

                            <div className="d-flex justify-content-center align-items-center flex-column"> 
                            <img id="dance" src="/images/story/wedding-rings.png" alt="w" />
                            <p>Σε αυτή την όμορφη στιγμή της ζωής μας, σας θέλουμε κοντά μας!</p>
                            </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Story;